/**
 * @flow
 * @relayHash 82ff462fde9246f36092c435ca7789db
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AdoptedSystemDocumentTemplatesQueryVariables = {|
  after?: ?string,
  first?: ?number,
  sort?: ?string,
|};
export type AdoptedSystemDocumentTemplatesQueryResponse = {|
  +adoptedSystemDocumentTemplates: ?{|
    +adoptedSystemDocumentTemplates: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +pk: ?number,
          +name: ?string,
          +total: ?number,
          +adopted: ?number,
          +documentPk: ?number,
        |}
      |}>,
    |},
    +error: ?{|
      +statusCode: ?number
    |},
    +otherTabTotal: ?number,
  |}
|};
export type AdoptedSystemDocumentTemplatesQuery = {|
  variables: AdoptedSystemDocumentTemplatesQueryVariables,
  response: AdoptedSystemDocumentTemplatesQueryResponse,
|};
*/


/*
query AdoptedSystemDocumentTemplatesQuery(
  $after: String
  $first: Int
  $sort: String
) {
  adoptedSystemDocumentTemplates(sort: $sort) {
    adoptedSystemDocumentTemplates(after: $after, first: $first) {
      totalCount
      edges {
        node {
          pk
          name
          total
          adopted
          documentPk
        }
      }
    }
    error {
      statusCode
    }
    otherTabTotal
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "adoptedSystemDocumentTemplates",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sort",
        "variableName": "sort",
        "type": "String"
      }
    ],
    "concreteType": "AdoptedSystemDocumentTemplateListType",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "adoptedSystemDocumentTemplates",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after",
            "type": "String"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first",
            "type": "Int"
          }
        ],
        "concreteType": "AdoptedSystemDocumentTemplatesConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "AdoptedSystemDocumentTemplatesEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "AdoptedSystemDocumentTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pk",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "total",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "adopted",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "documentPk",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "error",
        "storageKey": null,
        "args": null,
        "concreteType": "ErrorType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "statusCode",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "otherTabTotal",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AdoptedSystemDocumentTemplatesQuery",
  "id": "b95f73eb34dc5697b4bb129a867ad5b7",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AdoptedSystemDocumentTemplatesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "AdoptedSystemDocumentTemplatesQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "query AdoptedSystemDocumentTemplatesQuery(\n  $after: String\n  $first: Int\n  $sort: String\n) {\n  adoptedSystemDocumentTemplates(sort: $sort) {\n    adoptedSystemDocumentTemplates(after: $after, first: $first) {\n      totalCount\n      edges {\n        node {\n          pk\n          name\n          total\n          adopted\n          documentPk\n        }\n      }\n    }\n    error {\n      statusCode\n    }\n    otherTabTotal\n  }\n}\n";
(node/*: any*/).hash = 'e5046f37ad157276caa843693259c636';
module.exports = node;
